import classNames from "classnames"
import { ReactNode } from "react"
import { NavLink } from "react-router-dom"
import { SectionStatus } from "../../types/SectionStatus"
import { Icon } from "../Icon"

type IconMap = { [key in SectionStatus]: ReactNode }

export interface SideNavItemProps {
  to: string
  tooltip: string
  status?: SectionStatus
  children: string
  onClick?: () => void
}

const iconMap: IconMap = {
  current: <Icon variant="Current" />,
  completed: <Icon variant="Complete" />,
  upcoming: <Icon variant="Upcoming" />,
  errors: <Icon variant="Incomplete" />,
  touched: <Icon variant="Touched" />,
}

export function SideNavItem({
  to,
  tooltip,
  children,
  status = "upcoming",
  onClick,
}: SideNavItemProps) {
  return (
    <NavLink
      aria-label={`navigate to ${to}`}
      to={to}
      title={tooltip}
      onClick={onClick}
    >
      {({ isActive }) => (
        <div
          className={classNames(
            "p-[var(--component-sidebar-space)] rounded-[var(--component-menu-item-border-radius)]",
            {
              "bg-[color:var(--alias-color-bg-accent)]": isActive,
              "hover:bg-[color:var(--core-shadow-border-hover-color)]":
                !isActive,
            },
          )}
        >
          <div
            className={classNames(
              {
                "text-[color:var(--alias-color-text-on-accent)]": isActive,
                "text-[color:var(--alias-color-text-weakest)]": !isActive,
              },
              "flex items-center --alias-font-label-strong-line-height [font-family:var(--alias-font-label-strong-font-weight)] [font-size:var(--alias-font-label-strong-font-size)]",
            )}
          >
            <div className="flex mr-3">{iconMap[status]}</div>
            {children}
          </div>
        </div>
      )}
    </NavLink>
  )
}
